// Showcase Cards - native CSS scroll carousel with prev/next arrows
const showcaseCards = (): void => {
  const selectors = {
    section: '[data-showcase-cards]',
    viewport: '[data-showcase-carousel-viewport]',
    prev: '[data-showcase-carousel-prev]',
    next: '[data-showcase-carousel-next]',
  };

  const sections = document.querySelectorAll<HTMLElement>(selectors.section);

  sections.forEach((section) => {
    const viewport = section.querySelector<HTMLElement>(selectors.viewport);
    const prevBtn = section.querySelector<HTMLButtonElement>(selectors.prev);
    const nextBtn = section.querySelector<HTMLButtonElement>(selectors.next);

    if (!viewport || !prevBtn || !nextBtn) return;

    const getScrollAmount = (): number => {
      const slide = viewport.querySelector<HTMLElement>('.embla__slide');
      if (!slide || !slide.parentElement) return viewport.clientWidth;
      const gap =
        parseFloat(getComputedStyle(slide.parentElement).columnGap) || 0;
      return slide.offsetWidth + gap;
    };

    const updateButtons = (): void => {
      const maxScroll = viewport.scrollWidth - viewport.clientWidth;
      prevBtn.toggleAttribute('disabled', viewport.scrollLeft <= 1);
      nextBtn.toggleAttribute(
        'disabled',
        maxScroll <= 0 || viewport.scrollLeft >= maxScroll - 1
      );
    };

    prevBtn.addEventListener('click', () => {
      viewport.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', () => {
      viewport.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });
    viewport.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  });
};

export default showcaseCards;
